import { memo } from 'react';

// Components
import Textbox from '../../../../components/Textbox';

// Utils
import { isValidGSCProperty } from 'utils';

interface GSCPropertyInputProps {
  index: number;
  value: string;
  isRemoveable?: boolean;
  onChange: (newValue: string, index: number) => void;
  onRemove: (index: number) => void;
}

const onBlurValidateGSCProp = (evt: React.FocusEvent<HTMLInputElement>) => {
  const ERR_MSG =
    'Must be a valid URL (e.g. http://www.example.com or sc-domain:example.com)';
  const { value } = evt.currentTarget;

  if (!isValidGSCProperty(value)) {
    evt.currentTarget.setCustomValidity(ERR_MSG);
  } else {
    if (evt.currentTarget.validationMessage === ERR_MSG) {
      evt.currentTarget.setCustomValidity('');
    }
  }
};

function GSCPropertyInput({
  index,
  value,
  isRemoveable = false,
  onChange,
  onRemove,
}: GSCPropertyInputProps) {
  return (
    <div className="relative">
      <Textbox
        label="GSC Property"
        tooltip="onboarding.gsc_property"
        placeholder="http://www.domain.com or sc-domain:domain.com"
        onChange={(val) => onChange(val, index)}
        onBlur={(evt) => {
          onBlurValidateGSCProp(evt);
        }}
        value={value}
        required
      />
      {isRemoveable ? (
        <i
          id="x-icon"
          className="absolute top-0 right-0"
          onClick={() => onRemove(index)}
        />
      ) : null}
    </div>
  );
}

export default memo(GSCPropertyInput);
